module.exports = __webpack_public_path__ + "static/media/viewstudent.9bd94194.svg";